export const language = {
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',
    'Operation': '操作',
    'Search': '搜索',
    'Reset': '重置',
    'Status': '状态',
    'On': '启用',
    'Off': (<span style={{ color: "red" }}>禁用</span>),

    'UserName': '员工姓名',
    'User Phone Number': '员工手机号',
    'User Email ': '员工邮箱',
    'Add a User': '新增员工账号',
    'Set As Administrator': '设为管理员',
    'Please Confirm Whether To Delete This Account.': '请确认是否删除该账号',
    'Please Confirm Whether This Account is Set As an Administrator.': '请确认是否将该账号设置为管理员',
    'Binding Role': '绑定角色',
    'Inherit Authority': '继承权限',
    'Role Name': '角色名称',
    'Role Description': '角色说明',
    'This role name already exists. Please do not create it again': '该角色名称已存在，请勿重复创建',
    'Please Entry Role Name': '请输入角色名称',
    'Please  Entry Role Description': '请输入角色说明，上限50字',
    'Add a Role': '新增角色',
    'Edit Role': '编辑角色',
    'Are you sure you want to delete this role ? This deletion will lead to the invalidation of the role permissions of all accounts. ': '请确认是否删除该角色 ？该删除会导致所有账号该角色权限失效',
    'Please Confirm Whether To Perform This Operation.': '请确认是否执行该操作',
  },
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',
    'Operation': 'Operation',
    'Search': 'Search',
    'Reset': 'Reset',
    'Status': 'Status',
    'On': 'On',
    'Off': (<span style={{ color: "red" }}>Off</span>),

    'UserName': 'UserName',
    'User Phone Number': 'User Phone Number',
    'User Email ': 'User Email ',
    'Add a User': 'Add a User',
    'Set As Administrator': 'Set As Administrator',
    'Please Confirm Whether To Delete This Account.': 'Please Confirm Whether To Delete This Account.',
    'Please Confirm Whether This Account is Set As an Administrator.': 'Please Confirm Whether This Account is Set As an Administrator.',
    'Binding Role': 'Binding Role',
    'Inherit Authority': 'Inherit Authority',
    'Role Name': 'Role Name',
    'Role Description': 'Role Description',
    'This role name already exists. Please do not create it again': 'This role name already exists. Please do not create it again',
    'Please Entry Role Name': 'Please Entry Role Name',
    'Please  Entry Role Description': 'Please  Entry Role Description',
    'Add a Role': 'Add a Role',
    'Edit Role': 'Edit Role',
    'Are you sure you want to delete this role ?This deletion will lead to the invalidation of the role permissions of all accounts. ': 'Are you sure you want to delete this role ?This deletion will lead to the invalidation of the role permissions of all accounts. ',
    'Please Confirm Whether To Perform This Operation.': 'Please Confirm Whether To Perform This Operation.',
  }
};
